interface TooltipProps {
  content: string;
  children: React.ReactNode;
}

export function Tooltip({ content, children }: TooltipProps) {
  return (
    <div className="group relative inline-block">
      {children}
      <div className="invisible opacity-0 group-hover:visible group-hover:opacity-100 transition-opacity absolute z-50 bottom-full mb-2 left-1/2 -translate-x-1/2">
        <div className="bg-alpha-background-secondary text-white text-xs px-3 py-1.5 rounded-md border border-white/10">
          {content}
          <div className="absolute top-full left-1/2 -translate-x-1/2 -mt-[2px]">
            <div className="border-4 border-transparent border-t-alpha-background-secondary" />
          </div>
        </div>
      </div>
    </div>
  );
}
